import { FETCH_PAYMENT_STATUS } from 'actions/customer';

const initialState = {
  isLoading: false,
  paymentStatus: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const paymentStatusReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_PAYMENT_STATUS.REQUEST: {
      return { ...state, isLoading: true };
    }

    case FETCH_PAYMENT_STATUS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        paymentStatus: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case FETCH_PAYMENT_STATUS.FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    default:
      return { ...state };
  }
};

export default paymentStatusReducer;
